import { io } from 'socket.io-client';

class SocketioService {
  constructor() {}

  setupSocketConnection(loggedInUser) {
    //   console.log("Connector accessed " + process.env.local.VUE_APP_SOCKET_ENDPOINT)
    this.socket = io("https://app-psod.cratis.cloud",
    {
        query : {
            lawyer_id : loggedInUser
        }
    });

    

  }
}

export default new SocketioService();